import { EURO_10, EURO_20, EURO_3, EURO_30, EURO_5 } from "../../../App/GlobaleVariables"

export const DonationAmounts = [
    { id: 1, amount: "3", packageId: EURO_3 },
    { id: 2, amount: "5", packageId: EURO_5 },
    { id: 3, amount: "10", packageId: EURO_10 },
    { id: 4, amount: "20", packageId: EURO_20 },
    { id: 5, amount: "30", packageId: EURO_30 },
]
